import { Button } from '@givebutter/primitives/button';
import { faUndo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GivebutterAxiosError } from 'types/error';

interface UndoActionProps {
    undoFn: () => void;
    undoIsPending: boolean;
    undoIsError: boolean;
    undoError: GivebutterAxiosError | null;
}

const UndoAction = ({ undoFn, undoIsPending, undoIsError, undoError }: UndoActionProps) => {
    return (
        <div>
            {undoIsError && (
                <div className="text-sm text-red-600">
                    {undoError?.response?.data?.message ?? 'An unknown error occurred'}
                </div>
            )}

            <Button
                variant={'outline'}
                color={'neutral'}
                disabled={undoIsPending}
                className="!h-9 !border-none !px-3 !py-2 !text-sm text-gray-900"
                onClick={e => {
                    e.preventDefault();
                    undoFn();
                }}
            >
                <FontAwesomeIcon
                    icon={faUndo}
                    className={`text-gray-500 ${undoIsPending ? 'animate-reverse-spin' : ''}`}
                />
                <span>{undoIsPending ? 'Undoing' : 'Undo'}</span>
            </Button>
        </div>
    );
};

export { UndoAction };
